<template>
    <b-link id="btn-target-delete" :disabled="!canDoDelete" @click="deleteTarget(target.id)">
        <span :id="disableDeleteTargetAction">
            <p class="mb-0" style="font-size: 15px">
                <icon-delete />
            </p>
            <p class="mb-0">
                <small>{{ $t('form.button.delete') }}</small>
            </p>
            <b-tooltip :target="disableDeleteTargetAction" v-if="!canDoDelete">
                {{ viewDeleteTargetTooltipMessage }}
            </b-tooltip>
        </span>
    </b-link>
</template>

<script>
import Swal from 'sweetalert2'
import api from '@/services/api'
import { success, danger } from '@/lib/notification'
import { deleteConfirmationWithLoading } from '@/config/sweet-alert'
import { IconDelete } from '@/views/icons'

export default {
    name: 'DeleteTargetButton',
    components: {
        IconDelete,
    },
    props: {
        target: {
            type: Object,
            required: true,
        },
        currentEventPermissions: {
            type: Object,
            required: true,
        },
    },
    computed: {
        canDoDelete() {
            return this.currentEventPermissions[this.target.level].delete
        },
        disableDeleteTargetAction() {
            return 'disable-delete-target-action' + this.target.id
        },
        viewDeleteTargetTooltipMessage() {
            return (
                this.$t('profile.targetsTable.userWithoutPermissionToDeleteTarget', {
                    stageTitle: this.target.owner.stages.current.title,
                }) + this.viewStageCriteriaMessage
            )
        },
        viewStageCriteriaMessage() {
            const firstEntryCriteria = 0
            if (!this.hasEntryCriteria) {
                return ''
            }
            const criterionIdentifier =
                this.target.owner.stages.current.entryCriteria[firstEntryCriteria].criterion.identifier
            return this.$t(`stages.eventHasCriteriaMessages.${criterionIdentifier}`)
        },
        hasEntryCriteria() {
            return Object.keys(this.target.owner.stages.current.entryCriteria).length
        },
    },
    methods: {
        deleteTarget(targetId) {
            if (!this.canDoDelete) {
                return this.showSwal(
                    this.$t('notification.permissions.deleteDenied', {
                        item: this.$t('targets.target'),
                    })
                )
            }
            Swal({
                ...deleteConfirmationWithLoading,
                preConfirm: () => {
                    return this.deleteTargetFromAPI(targetId)
                },
            })
                .then((resp) => {
                    const { value } = resp
                    if (value) {
                        return this.handleDelete(value)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    return danger()
                })
        },
        deleteTargetFromAPI(id) {
            return api.delete(`/goals/${id}`).catch((e) => {
                throw new e()
            })
        },
        handleDelete(value) {
            const error = value.data.messages[0]
            if (error.params == 'usedInFormula') {
                return this.showSwal(
                    this.$t('notification.somethingWentWrong'),
                    'error',
                    this.$t('notification.delete.usedInFormula')
                )
            }
            if (error.status != 'success') {
                return danger()
            }
            this.notificationTargetDeletedSuccessfully()
            this.$emit('reload')
            this.$router.back()
            return
        },
        notificationTargetDeletedSuccessfully() {
            success(
                this.$t('notification.deletedSuccessfully', {
                    item: this.$t('targets.target'),
                })
            )
        },
    },
}
</script>
<style lang="scss" scoped>
#btn-target-delete.disabled {
    color: #6e6e6e;
    cursor: not-allowed;
    opacity: 1;
    text-decoration: none;
}
#btn-target-delete svg {
    fill: #009bda;
}
#btn-target-delete.disabled svg {
    fill: #6e6e6e;
}
</style>
